import CSCPTable from "../cscp-table"

export default class MembersReportjs extends CSCPTable {
    constructor() {
        super();
    }

    initSettings() {
        let that = this;
        let hidWebsiteName = $('#hidWebsiteName').val() !== '' ? $('#hidWebsiteName').val() : 'CSCP';
        const domain = window.location.origin;

        that.instance = "cscpjs.default.membersReportjs";
        that.method = "/Reports/MembersPaging";
        that.exportController = "/Reports";
        that.exportAction = "/Members";
        that.tableId = "membersTable";
        that.searchBtnEleId = "membersTableSearch";
        that.exportBtnEleId = "membersTableExport";

        that.columns = [
            {
                customContent: (row) => {
                    return '<span class="item-index"></span>';
                },
                class: "custom-padding"
            },
            {
                customContent: (row) => {
                    var memName = (row.FirstName !== '' || row.LastName !== '') ? row.FirstName + ' ' + row.LastName : 'ugcitem-' + row.ID;
                    return '<a target="_blank" href="http://manager-ca.agilitycms.com/' + hidWebsiteName + '/en-us/user-content/ugclist-10/ugcitem-' +
                        row.ID +
                        '">' +
                        memName +
                        '</a>';
                },
                class: "custom-padding record-name"
            },
            {
                customContent: (row) => {
                    return '<a target="_top" href="mailto:' + row.Email + '">' + row.Email + '</a>';
                },
                class: "custom-padding record-email"
            },
            {
                customContent: (row) => {
                    return row.Member;
                },
                class: "custom-padding"
            },
            {
                customContent: (row) => {
                    return (row.ReadyforAudit !== null ? row.ReadyforAudit : '');
                },
                class: "custom-padding checkReadyforAudit"
            },
            {
                customContent: (row) => {
                    return (row.Audited !== null ? row.Audited : '');
                },
                class: "custom-padding checkAudited"
            },
            {
                customContent: (row) => {
                    var flags = [];
                    if (row.OnExtension) {
                        flags.push('On Extension');
                    }
                    if (row.Grace) {
                        flags.push('Grace');
                    }
                    if (row.NotInGoodStandingOverride) {
                        flags.push('NIGS');
                    }

                    return flags.length > 0 ? flags.join(',') : '---';
                },
                class: "custom-padding"
            },
            {
                customContent: (row) => {
                    return '<a target="_blank" href="' + domain + '/Reports/CEUCertificationReport?user=' +
                        that.additionalAttr.user +
                        '&hash=' +
                        that.additionalAttr.hash +
                        '&uid=' +
                        row.ID +
                        '">View</a>';
                },
                class: "custom-padding record-ceu"
            },
            {
                customContent: (row) => {
                    if ( typeof(row.GuarantorID) !== 'undefined' && row.GuarantorID !== 0) {
                        return '<a target="_blank" href="http://manager-ca.agilitycms.com/' + hidWebsiteName + '/en-us/user-content/ugclist-18/ugcitem-' +
                            row.GuarantorID +
                            '">' + (row.GuarantorName !== '' ? row.GuarantorName : 'View')+'</a>';
                    }

                    return '---';
                },
                class: "custom-padding record-ceu"
            },
            {
                customContent: (row) => {
                    return row.AdminComments;
                },
                class: "custom-padding"
            },
            { data: "Paid", class: "custom-padding checkPaid" },
            { data: "Declared", class: "custom-padding checkDeclared" },
            {
                customContent: (row) => {
                    return row.CycleStartDate;
                },
                class: "custom-padding"
            },
            {
                customContent: (row) => {
                    return row.CurrentYear;
                },
                class: "custom-padding"
            },
            //{
            //    customContent: (row) => {
            //        return row.ReportPeriod;
            //    },
            //    class: "custom-padding"
            //},
        ];
        that.filterContainerEleId = "reportFilterForm";
    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/membersReport.js